import { render, staticRenderFns } from "./BinCollectionSchedule.vue?vue&type=template&id=53903cf2&"
import script from "./BinCollectionSchedule.vue?vue&type=script&lang=js&"
export * from "./BinCollectionSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports